import React, { useState } from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";

interface ByzMuiSearchFilterButtonProps extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  width?: string;
  height?: string;
}

const StyledButton = styled(Button)<{ width?: string | number; height?: string | number }>(
  ({ width, height }) => ({
    width: width,
    height: height,
    borderRadius: "100px",
    padding: 0,
    minWidth: "unset",
    backgroundColor: "#2196F3",
    transition: "background-color 0.2s ease-in-out",
    boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#2979C3",
    },
  })
);


const ByzMuiSearchFilterButton: React.FC<ByzMuiSearchFilterButtonProps> = ({ 
  onClick, 
  width = "65px", 
  height = "65px" 
}) => {
  const [hover, setHover] = useState(false);
  const numericWidth = parseInt(width, 10); // Convert width to number
  const numericHeight = parseInt(height, 10); // Convert height to number

  const buttonContent = (
    <img
      src="/assets/icons/searchfilter/searchfilter.svg"
      alt="Ara & Filtrele"
      style={{
        width: `${numericWidth - 20}px`,
        height: `${numericHeight - 20}px`,
        transition: "opacity 0.2s ease-in-out",
        opacity: hover ? 1 : 0.9,
      }}
    />
  );

  return (
    <StyledButton
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      width={width}
      height={height}
    >
      {buttonContent}
    </StyledButton>
  );
};

export default ByzMuiSearchFilterButton;
